import React from "react";
import { Container } from "react-bootstrap";
import Component_1 from "../tabs_common_components/component_1/Component_1";
import Component_2 from "../tabs_common_components/component_2/Component_2";
import Component_3 from "../tabs_common_components/component_3/Component_3";
import Component_5 from "../tabs_common_components/component_5/Component_5";

const Group_fitness = () => {
  const focusData = [
    {
      id: 1,
      icon: "/assets/images/sports-program/component-3/strength.png",
      title: "Strength",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 2,
      icon: "/assets/images/sports-program/component-3/endurance.png",
      title: "Endurance",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 3,
      icon: "/assets/images/sports-program/component-3/core-stability.png",
      title: "Core Stability",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 4,
      icon: "/assets/images/sports-program/component-3/flexibility.png",
      title: "Flexibility",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 5,
      icon: "/assets/images/sports-program/component-3/speed-agility.png",
      title: "Speed & Agility",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 6,
      icon: "/assets/images/sports-program/component-3/body-toning.png",
      title: "Body Toning & Structure",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 7,
      icon: "/assets/images/sports-program/component-3/fat-loss.png",
      title: "Fat Loss",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
  ];

  return (
    <section className="group_fitness_section">
      <Container>
        <Component_1
          topDescn={
            "Our Adult Group Fitness Program is designed to help you stay fit, active, and motivated in a fun group environment. Whether your goal is weight loss, strength building, or overall fitness, our sessions are structured to deliver results for all fitness levels."
          }
          title={"Program Structure"}
          features={[
            { label: "10 min:", value: "Warm-up and Mobility Training " },
            {
              label: " 30 min:",
              value: "multiskill Activities  ",
            },
            {
              label: "",
              value: " Weight Training   ",
              // value:"Body weight Training" ,
              // value:"Agility Workout" ,
              // value:"⁠core Exercises",
              // value:" ⁠jumping Exercises ",
              // value:" ⁠functional Training ",
              // value:"yoga",
            },

            {
              label: "",
              value: "Body Weight Training",
            },
            {
              label: "",
              value: "Agility Workout",
            },
            {
              label: "",
              value: "⁠core Exercises",
            },
            {
              label: "",
              value: "⁠jumping Exercises",
            },
            {
              label: "",
              value: "⁠functional Training",
            },
            {
              label: "",
              value: "yoga",
            },

               {
              label: "",
              value: "Daily Seperate Workouts",
            },
               {
              label: "10 min",
              value: "Cool Down & Stretching",
            },
          ]}
          imgSrc="./assets/images/gallery/img-9.png"
        />

        <Component_5
          title={"Benefits of Group Fitness"}
          features={[
            "Boosts stamina and energy levels",
            "Helps in weight loss and muscle toning",
            "Improves flexibility and posture",
            "Reduces stress and improves mental health",
            "Keeps you motivated with group support",
            " flexibility ",
            "core strength ",
            "speed ",
            "⁠strength ",
          ]}
        />

        <Component_2
          title={"Weekly Workout Plan"}
          imgSrc="./assets/images/sports-program/component-2/friend.png"
          features={[
            {
              label: "Two Strength Sessions: ",
              value: "Focused on back, biceps, shoulders, chest, and legs.",
              imgSrc: "./assets/images/sports-program/component-2/friend.png",
            },
            {
              label: "One Yoga Session:  ",
              value:
                "Conducted by a certified yoga trainer for flexibility and recovery.",
              imgSrc: "./assets/images/sports-program/component-2/yoga.png",
            },
            {
              label: "Additional Sessions: ",
              value:
                "Running, HIIT, hill runs, ladder & hurdle drills, jumping, and agility exercises.",
              imgSrc: "./assets/images/sports-program/component-2/calender.png",
            },
          ]}
        />

        <Component_3 focusData={focusData} />
      </Container>
    </section>
  );
};

export default Group_fitness;
